import { render, staticRenderFns } from "./PlatformKeys.vue?vue&type=template&id=00a0b78b&"
import script from "./PlatformKeys.vue?vue&type=script&lang=js&"
export * from "./PlatformKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports